import { Head, Link, usePage } from '@inertiajs/react'
import { Button } from '../components/core/Button.jsx'

// The admin screen's frame — the operator's own view, 2026-10-12. Not the
// signed-in header: that one is a customer's, scoped to one account, and these
// pages read across every account.
const TABS = [
  ['Accounts', '/admin/accounts'],
  ['Businesses', '/admin/businesses'],
  ['Runs', '/admin/runs'],
  ['Emails', '/admin/emails'],
  ['Free checks', '/admin/free-checks'],
]

export function AdminLayout({ title, children }) {
  const { url } = usePage()

  return (
    <>
      <Head title={`Admin · ${title}`} />
      <div className="min-h-screen">
        <header className="border-b border-[color:var(--border-subtle)]">
          <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center gap-x-6 gap-y-3 px-4 py-4 sm:px-6">
            <span className="sp-label">Spruce admin</span>
            <nav className="flex flex-wrap gap-1">
              {TABS.map(([label, href]) => {
                const active = url === href || (href === '/admin/accounts' && url === '/admin')
                return (
                  <Link
                    key={href}
                    href={href}
                    className={`rounded-md px-3 py-1.5 text-[13.5px] no-underline ${active ? 'bg-[color:var(--surface-raised)] text-[color:var(--text-strong)]' : 'text-[color:var(--text-muted)]'}`}
                  >
                    {label}
                  </Link>
                )
              })}
            </nav>
            <div className="ml-auto flex items-center gap-3">
              <Button variant="primary" size="sm" href="/admin/accounts/new">Add an account</Button>
              <Link href="/dashboard" className="text-[13.5px] text-[color:var(--text-muted)]">Back to the app</Link>
            </div>
          </div>
        </header>
        <main className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6">
          <h1 className="page-title mb-6">{title}</h1>
          <div className="flex flex-col gap-6">{children}</div>
        </main>
      </div>
    </>
  )
}

// A plain table that scrolls sideways inside its card rather than widening the
// page, so the admin screen works on a phone. `columns` is [key, label, align?].
export function Table({ columns, rows, empty = 'Nothing yet.' }) {
  if (rows.length === 0) return <p className="sp-body-sm text-[color:var(--text-muted)]">{empty}</p>

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-[13px]">
        <thead>
          <tr>
            {columns.map(([key, label, align]) => (
              <th key={key} className={`whitespace-nowrap border-b border-[color:var(--border-subtle)] px-2 py-2 font-medium text-[color:var(--text-muted)] ${align === 'right' ? 'text-right' : 'text-left'}`}>
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={row.id ?? i}>
              {columns.map(([key, , align]) => (
                <td key={key} className={`border-b border-[color:var(--border-subtle)] px-2 py-2 align-top text-[color:var(--text-body)] ${align === 'right' ? 'text-right tabular-nums' : ''}`}>
                  {row[key] ?? '—'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
